import './index.sass';
import {initTooltip} from '~/blocks/tooltip'

export default () => {
  initTooltip();
}